export const CARS = Object.freeze([
  { id: 'ember', number: '07', color: '#e8343f', accent: '#ffcf49', shape: 'ember' },
  { id: 'thunder', number: '12', color: '#237ade', accent: '#e8f1ff', shape: 'thunder' },
  { id: 'eagle', number: '23', color: '#ffbd29', accent: '#202e3d', shape: 'eagle' },
  { id: 'venom', number: '36', color: '#21a96c', accent: '#cafa86', shape: 'venom' },
  { id: 'titan', number: '88', color: '#cfdae4', accent: '#8750ce', shape: 'titan' },
].map(Object.freeze));
export const DEFAULT_AMOUNTS = Object.freeze([300, 500, 800]);
export const DEFAULT_RETURN_RATE = 1.10;
export const DEFAULT_CHANCES_BASIS_POINTS = Object.freeze([2400, 2200, 2000, 1800, 1600]);

// The admin game configuration may override these; the shipped values stay in place
// until the browser fetches the configured ones. A round draws one chance per car and
// prices it as returnRate / chance, so the two always travel together.
let amounts = DEFAULT_AMOUNTS;
let returnRate = DEFAULT_RETURN_RATE;
let chancesBasisPoints = DEFAULT_CHANCES_BASIS_POINTS;

function chancesValid(values) {
  if (!Array.isArray(values) || values.length !== CARS.length) return false;
  if (!values.every(value => Number.isInteger(value) && value >= 100 && value <= 10000)) return false;
  return values.reduce((total, value) => total + value, 0) === 10000;
}

/**
 * Applies the rules the server currently publishes. A malformed payload changes
 * nothing, so a stale or offline page keeps a consistent set of values.
 */
export function configure(options = {}) {
  const nextAmounts = options.stakes === undefined ? null : options.stakes;
  const nextReturnRate = options.returnRate === undefined ? null : Number(options.returnRate);
  const nextChances = options.chanceBasisPoints === undefined ? null : options.chanceBasisPoints;
  const amountsValid = nextAmounts === null
    || (Array.isArray(nextAmounts) && nextAmounts.length > 0
      && nextAmounts.every(amount => Number.isInteger(amount) && amount > 0)
      && nextAmounts.every((amount, index) => index === 0 || amount > nextAmounts[index - 1]));
  const rateValid = nextReturnRate === null || (Number.isFinite(nextReturnRate) && nextReturnRate > 0);
  const chancesOk = nextChances === null || chancesValid(nextChances);
  if (!amountsValid || !rateValid || !chancesOk) return currentRules();

  if (nextAmounts !== null) amounts = Object.freeze([...nextAmounts]);
  if (nextReturnRate !== null) returnRate = nextReturnRate;
  if (nextChances !== null) chancesBasisPoints = Object.freeze([...nextChances]);
  return currentRules();
}

/** One entry per drawn profile, priced the way the API prices it. */
export function currentProfiles() {
  return Object.freeze(chancesBasisPoints.map((basisPoints, index) => Object.freeze({
    index,
    chance: basisPoints / 10000,
    factor: returnRate / (basisPoints / 10000),
  })));
}

export function currentStakes() { return amounts; }

export function currentReturnRate() { return returnRate; }

export function currentChanceBasisPoints() { return chancesBasisPoints; }

export function currentRules() {
  return { stakes: amounts, returnRate, chanceBasisPoints: chancesBasisPoints };
}

/** Every credit a win may pay at this stake, one per drawn profile. */
export function rewardsFor(stake) {
  return currentProfiles().map(profile => Math.round(stake * profile.factor));
}
